// @ts-nocheck
import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import Toast from './Toast';

export type ToastKind = 'success' | 'error' | 'info';

type ToastItem = { id: number; message: string; type: ToastKind; duration?: number };

type ToastCtx = {
  toast: (message: string, type?: ToastKind, duration?: number) => void;
};

const Ctx = createContext<ToastCtx>({ toast: () => {} });

export const useToast = () => useContext(Ctx);

export const ToastProvider: React.FC<{ children: React.ReactNode; maxStack?: number }> = ({ children, maxStack = 3 }) => {
  const [stack, setStack] = useState<ToastItem[]>([]);
  const seq = useRef(1);

  const toast = useCallback((message: string, type: ToastKind = 'info', duration = 3000) => {
    const id = seq.current++;
    setStack((prev) => {
      const next = [...prev, { id, message, type, duration }];
      // trim queue to keep last `maxStack`
      return next.slice(-maxStack);
    });
  }, [maxStack]);

  const remove = useCallback((id: number) => {
    setStack((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const ctxValue = useMemo(() => ({ toast }), [toast]);

  return (
    <Ctx.Provider value={ctxValue}>
      {children}
      {/* Toast viewport */}
      <div className="fixed bottom-4 right-4 z-[60] flex flex-col gap-2 pointer-events-none">
        <AnimatePresence initial={false}>
          {stack.map((t) => (
            <Toast key={t.id} message={t.message} type={t.type} duration={t.duration} onClose={() => remove(t.id)} />
          ))}
        </AnimatePresence>
      </div>
    </Ctx.Provider>
  );
};
